import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MenuItemFavourite } from '../../models/MenuItemFavourite';
import { Observable, Subscription } from 'rxjs';
import { NavigationService } from '../../services/navigation.service';
import { MenuItem } from '../../models/MenuItem';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'src/app/shared/personnel-files/services/company.service';
import { Company } from 'src/app/shared/personnel-files/models/Company';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-bottom-navigation-bar',
  templateUrl: './bottom-navigation-bar.component.html',
  styleUrls: ['./bottom-navigation-bar.component.scss'],
})
export class BottomNavigationBarComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  private isLhr = false;

  public companies: Company[] = [];
  public favourites: MenuItemFavourite[] = [];
  public navigationStructure$: Observable<MenuItem>;
  public home: MenuItem;
  public menuOpen = false;
  public showFavourites = false;
  public selectedMenuId: number | null = null;
  public isActivePage: boolean = false;

  private flatMenu: MenuItem[] = [];
  private pendingMenuId: number | null = null;

  @ViewChild('menuContainer') menuRef!: ElementRef;
  @ViewChild('modalcontent') modalcontent: any;

  constructor(
    private _companyService: CompanyService,
    private _navigationService: NavigationService,
    private _router: Router,
    private _route: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this._subscriptions.push(
      this._route.queryParamMap.subscribe(qp => {
        const id = Number(qp.get('menuItem'));
        if (!id) return;
        if (!this.flatMenu || this.flatMenu.length === 0) {
          this.pendingMenuId = id;
          return;
        }

        const mi = this.flatMenu.find(x => x.id === id);
        this.selectedMenuId = id;
        this.isActivePage = !!mi?.isActive;
      })
    );

    this._subscriptions.push(
      this._navigationService.fetchMenu().subscribe(homeData => {
        const flatMenu: MenuItem[] = [];
        this.home = new MenuItem(homeData);

        const collect = (item: MenuItem) => {
          flatMenu.push(item);
          (item.subPages || []).forEach(collect);
        };
        collect(this.home);

        this.flatMenu = flatMenu;
        this.selectedMenuId = this.home.id;
        this.isActivePage = this.home.isActive;

        if (this.pendingMenuId) {
          const mi = this.flatMenu.find(x => x.id === this.pendingMenuId);
          this.selectedMenuId = this.pendingMenuId;
          this.isActivePage = !!mi?.isActive;
          this.pendingMenuId = null;
        }

        // Favourites
        this._navigationService.getFavourites().subscribe(favo => {
          this.favourites = favo
            .map(fav => ({ ...fav, menuItem: flatMenu.find(x => x.id === fav.menuItemId) }))
            .filter(fav => fav.menuItem != null)
            .sort((a, b) => a.sortOrder - b.sortOrder);
        });
      })
    );

    this._subscriptions.push(
      this._companyService.get().subscribe(e => {
        this.companies = e.filter(c => c.id > 1);
      })
    );
  }

  public clickFavourite(menuItem: MenuItem): void {
    this.menuOpen = false;
    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToFavorites(menuItem.getAngularUrl(), menuItem);
      return;
    }
    if (menuItem && (menuItem.id == 697 || menuItem.id == 698 || menuItem.id == 699 || menuItem.id == 700)) {
      let parameters = {};
      let url = 'chr/company';
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments';
          break;
        case 698:
        case 699: url = 'chr/companypositions';
          break;
        case 700: url = 'chr/companyfunctions';
          break;
      }

      if (this.companies.length == 1) {
        parameters['item'] = this.companies[0].id;
        parameters['employee'] = null;
        this.navigateToFavorites(url, menuItem, parameters);
      } else {
        let modal = this.modalService.open(this.modalcontent, { backdrop: true, size: 'sm' });
        modal.result.then((a) => {
          parameters['item'] = a;
          parameters['employee'] = null;
          this.navigateToFavorites(url, menuItem, parameters);

        }, () => { })
      }
    }
  }

  public clickMenuItem(id?: number) {
    // Search for the menu item by ID or use the home item if no ID is provided
    const menuItem: MenuItem | undefined = id
      ? this.flatMenu.find(m => m.id === id)
      : this.home;

    if (!menuItem) {
      return;
    }
    this.selectedMenuId = menuItem.id;
    this.isActivePage = menuItem.isActive;
    let url = menuItem.getAngularUrl();
    let params: any = { menuItem: menuItem.id };

    if ([697, 698, 699, 700].includes(menuItem.id)) {
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments'; break;
        case 698:
        case 699: url = 'chr/companypositions'; break;
        case 700: url = 'chr/companyfunctions'; break;
      }

      if (this.companies.length === 1) {
        params.item = this.companies[0].id;
        this._router.navigate([url], {
          queryParams: params,
          queryParamsHandling: 'merge'
        });
        this.navigateToUrl(url, menuItem.id, params);
        return;
      }

      const modal = this.modalService.open(this.modalcontent, { size: 'sm' });
      modal.result.then((companyId: number) => {
        params.item = companyId;
        this._router.navigate([url], {
          queryParams: params,
          queryParamsHandling: 'merge'
        });
        this.navigateToUrl(url, menuItem.id, params);
      });
      return;
    }

    this._router.navigate([url], {
      queryParams: params,
      queryParamsHandling: 'merge'
    });
    this.navigateToUrl(url, menuItem.id, params);
  }

  public toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  // Navigates to the page with the given URL and menu item.
  private navigateToFavorites(url: string, menuItem: MenuItem, extraQueryParams?) {
    this._router.navigate([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
  }

  private navigateToUrl(url: string, id: number, extraQueryParams?) {
    this._router.navigate([url], { queryParams: { menuItem: id, ...extraQueryParams }, queryParamsHandling: 'merge' });
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: MouseEvent) {
    const clickedInside = this.menuRef?.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.menuOpen = false;
    }
  }
  ngOnDestroy() {
  }
}